module.exports = __webpack_public_path__ + "img/file-minus-02.fdf498a5.svg";